import { cn } from '@e-kyc/utils';

import { CheckRoundedIcon } from '../../icons';

type MenuItemProps = React.ComponentProps<'div'> & {
  selected?: boolean;
};

export function MenuItem(props: Readonly<MenuItemProps>) {
  const { className, children, selected = false, ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        'hover:bg-primary-100 flex items-center gap-2 rounded-md px-2 py-2.5',
        selected && 'bg-primary-100',
        className,
      )}
    >
      <p className='text-text-primary flex-1'>{children}</p>
      {selected ? <CheckRoundedIcon className='text-primary-500 size-6' /> : null}
    </div>
  );
}
